import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../../locales/en/common.json' with { type: 'json' };
import esCommon from '../../locales/es/common.json' with { type: 'json' };
export const SUPPORTED_LANGUAGES = ['en', 'es'];
export const DEFAULT_NS = 'common';
/** Shared resource bundles. Apps may merge their own namespaces on top. */
export const resources = {
    en: { common: enCommon },
    es: { common: esCommon },
};
/**
 * Initialise the shared i18next instance with react-i18next.
 * `fallbackLng: 'en'`, `defaultNS: 'common'`. EN + ES from day one (D-08).
 */
export function initI18n(options = {}) {
    const merged = {
        en: { ...resources.en },
        es: { ...resources.es },
    };
    if (options.extraResources) {
        for (const [lng, namespaces] of Object.entries(options.extraResources)) {
            const base = (merged[lng] ?? {});
            const next = { ...base };
            // Merge PER NAMESPACE, not per language. Both apps ship their own `common`
            // bundle, and a shallow spread let it replace the kit's wholesale — so a
            // string the kit itself renders (the mobile nav's own labels) resolved to
            // its raw key and shipped "nav.openMenu" as an aria-label. App keys still
            // win on a collision; kit-only keys now survive.
            for (const [ns, bundle] of Object.entries(namespaces)) {
                const existing = next[ns];
                next[ns] =
                    existing && typeof existing === 'object' && bundle && typeof bundle === 'object'
                        ? { ...existing, ...bundle }
                        : bundle;
            }
            merged[lng] = next;
        }
    }
    if (!i18n.isInitialized) {
        void i18n.use(initReactI18next).init({
            resources: merged,
            lng: options.lng ?? 'en',
            fallbackLng: 'en',
            defaultNS: DEFAULT_NS,
            ns: [DEFAULT_NS],
            interpolation: { escapeValue: false },
        });
    }
    return i18n;
}
export { I18nextProvider as I18nProvider, Trans, useTranslation } from 'react-i18next';
export { i18n };
